/* eslint-disable no-unused-vars */
import React from 'react';
import PropTypes from 'prop-types';
import { useUser } from '../../../hooks/user/useUser';
import { usePayment } from '../../../hooks/payment/usePayment';

// const initializeTellerPayment = async (email, amount) => {
//   try {
//     const payload = {
//       action: 'initializeTheTeller',
//       amount,
//       email,
//     };
//     const response = await axios.post(
//       INITIALIZE_TELLER_PAYMENT_API_URL,
//       qs.stringify(payload),
//     );
//     window.open(`${response.data.checkout_url}`, '_blank');
//   } catch (e) {
//     // console.log(e);
//   }
// };

const PaymentChannels = ({
  checked,
  amount,
  paystackPlanCode,
  ravePlanCode,
  monthNum,
}) => {
  const {
    // loading,
    payForPlanWithFlutterWave,
    payForRecurringPlanWithFlutterWave,
    payForPlanWithSlydePay,
    payForPlanWithPaystack,
    payForRecurringPlanWithPaystack,
  } = usePayment();

  const [{ user }] = useUser();

  const payWithRave = () => {
    if (checked && monthNum !== '2')
      return payForRecurringPlanWithFlutterWave(ravePlanCode, user, amount);
    return payForPlanWithFlutterWave(amount, user);
  };

  const payWithSlydePay = () => payForPlanWithSlydePay(amount, user);

  const payWithPaystack = () => {
    if (checked && monthNum !== '2')
      return payForRecurringPlanWithPaystack(paystackPlanCode, user);
    return payForPlanWithPaystack(amount, user);
  };

  return (
    <span className="">
      <div className="d-md-none">
        <div className="mt-2 d-flex row">
          <div className="col-auto d-flex">
            <span className="payChannel_text text-wrap mr-1 mt-2">
              Pay with:
            </span>
            <div className="btn-group btn-group-sm" role="group">
              {/* {loading ? ( */}
              {/*  <button */}
              {/*    type="button" */}
              {/*    id="btn" */}
              {/*    className="btn btn-outline-info mr-1" */}
              {/*    disabled={loading} */}
              {/*  > */}
              {/*    Initializing Payment... */}
              {/*  </button> */}
              {/* ) : ( */}
              {/*  <button */}
              {/*    type="button" */}
              {/*    id="btn" */}
              {/*    className="btn btn-outline-info w-50 mr-1" */}
              {/*    onClick={() => payWithSlydePay()} */}
              {/*  > */}
              {/*    <img src="images/slydepay.png" width="40%" alt="slydepay logo" /> */}
              {/*  </button> */}
              {/* )} */}
              <button
                type="button"
                // id="btn"
                className="btn btn-outline-info mr-1"
                onClick={() => payWithRave()}
              >
                <img
                  src="images/flutterwave.png"
                  width="100px"
                  alt="flutterwave logo"
                />
              </button>
              <button
                type="submit"
                className="btn btn-outline-info"
                onClick={() => payWithPaystack()}
              >
                <img
                  alt="paystack logo"
                  src="images/paystack.png"
                  width="115px"
                />
              </button>
              {/* <button */}
              {/*  type="button" */}
              {/*  id="btn" */}
              {/*  className="btn btn-outline-info w-50 mr-1" */}
              {/* > */}
              {/*  <img src="images/theteller1.png" width="40%" alt="theteller logo" /> */}
              {/* </button> */}
            </div>
          </div>
        </div>
      </div>

      <div className="d-none d-md-flex">
        <span className="payChannel_text mr-1 mt-1 text-nowrap">Pay with:</span>
        <div className="btn-group btn-group-sm" role="group">
          {/* {loading ? (
            <button
              type="button"
              id="btn"
              className="btn btn-info mb-1"
              disabled={loading}
            >
              Initializing...
            </button>
          ) : (
            <button
              type="button"
              id="btn"
              className="btn btn-outline-info w-50 mb-1"
              onClick={() => payWithSlydePay()}
            >
              <img src="images/slydepay.png" width="100%" alt="slydepay logo" />
            </button>
          )} */}
          <button
            type="button"
            className="btn btn-outline-info mr-1 w-100"
            onClick={() => payWithRave()}
          >
            <img
              src="images/flutterwave.png"
              width="50%"
              alt="flutterwave logo"
            />
          </button>
          <button
            type="submit"
            className="btn btn-outline-info w-100"
            onClick={() => payWithPaystack()}
          >
            <img alt="paystack logo" src="images/paystack.png" width="50%" />
          </button>
          {/* <button */}
          {/*  type="button" */}
          {/*  id="btn" */}
          {/*  className="btn btn-outline-info w-50 mr-1" */}
          {/*  onClick={() => initializeTellerPayment(user.email, amount)} */}
          {/* > */}
          {/*  <img src="images/theteller1.png" width="100%" alt="theteller logo" /> */}
          {/* </button> */}
        </div>
      </div>
    </span>
  );
};

PaymentChannels.propTypes = {
  amount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  checked: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]).isRequired,
  paystackPlanCode: PropTypes.string.isRequired,
  ravePlanCode: PropTypes.string.isRequired,
  monthNum: PropTypes.string.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
};

export default PaymentChannels;
